import type { PaginatedLead, StoredLead } from 'modules/leads/types';

/**
 * Reduces the nested assignee and interventions of a lead to their ids, as the store keeps it.
 * @param lead the lead as the API returns it
 */
export const formatLead = ({ intervention, directMessage, assignee, ...lead }: PaginatedLead): StoredLead => ({
  ...lead,
  assigneeId: assignee?.id,
  interventionId: intervention.id,
  directMessageId: directMessage?.id,
});
